module.exports = __webpack_public_path__ + "static/media/mask-pink-tablet@2x.c900c3c1.png";